<template lang="pug">
  m-table(
    store-name="sessions"
    :headers="headers"
    :query-filter="queryFilter"
    :item-actions="actions"
  )
</template>

<script>
import MTable from '~/components/modules/tables/m-table'

export default {
  name: 'BlockUserSessions',
  components: { MTable },
  props: {
    userId: {
      type: String,
      default: null
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'IP',
          value: 'ip',
          sortable: false,
          filterable: false
        },
        {
          text: 'Device',
          value: 'userAgent',
          sortable: false,
          filterable: false
        },
        {
          text: 'Last access',
          value: 'ip',
          valueFormatter: session =>
            session.lastAccessAt
              ? this.$moment.parseZone(session.lastAccessAt).format('DD.MM.YYYY')
              : '-',
          sortable: false,
          filterable: false
        },
        {
          text: 'Actions',
          align: 'center',
          value: 'actions',
          width: '120',
          sortable: false,
          filterable: false
        }
      ]
    },
    queryFilter() {
      return {
        'user.id': this.userId
      }
    },
    actions() {
      return [
        {
          name: 'delete',
          text: 'Revoke',
          call: session => this.revokeSession(session)
        }
      ]
    }
  },
  methods: {
    async revokeSession(session) {
      console.log(session)
      try {
        await this.$store.dispatch('sessions/delete', { id: session.id })
      } catch (e) {
        this.$handlers.error(e, this)
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
